/**
 * Režim tisku mapové vrstvy.
 */
enum LayerPrintMode {
    /**
     * Tisk vrstev je zakázán.
     */
    DISABLED = 'DISABLED',

    /**
     * Tisknout se budou aktuálně viditelné vrstvy.
     */
    VISIBLE = 'VISIBLE',

    /**
     * Tisknout se budou vrstvy nastavené v aktuálním v téma konfigurace.
     */
    TOPIC = 'TOPIC',
}

export default LayerPrintMode;
